module.exports = { apiServer: 'https://api.standard.in-store.hk/', AdminServer: 'https://admin.standard.in-store.hk/', env: 'prod' };
